export const messages = {
  studies: 'Studies',
  components: 'Components',
};
